import * as React from 'react';

export const TrackingListener = React.lazy(() => import('./TrackingListener'));
